import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function MapUpdater({ center }) {
  const map = useMap();
  
  useEffect(() => {
    if (center && center.lat && center.lng) {
      map.setView(center, 13);
    }
  }, [center, map]);
  
  return null;
}

const LiveMap = ({ height = "300px", width = "100%", vehiclePosition = null }) => {
  // Initialize with vehicle position if available, otherwise null
  const getInitialPosition = () => {
    if (vehiclePosition && vehiclePosition.latitude && vehiclePosition.longitude) {
      return {
        lat: vehiclePosition.latitude,
        lng: vehiclePosition.longitude
      };
    }
    return null;
  };

  const [currentPosition, setCurrentPosition] = useState(getInitialPosition);
  const [loading, setLoading] = useState(!vehiclePosition);
  const [error, setError] = useState(null);
  const [mapKey, setMapKey] = useState(0); // Key to force map remount

  useEffect(() => {
    // If we have a vehicle position from OBD data, use that immediately
    if (vehiclePosition && vehiclePosition.latitude && vehiclePosition.longitude) {
      setCurrentPosition({
        lat: vehiclePosition.latitude,
        lng: vehiclePosition.longitude
      });
      setLoading(false);
      // Force map to remount with new position
      setMapKey(prev => prev + 1);
      return;
    }

    // Otherwise, fall back to browser geolocation
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setCurrentPosition({
            lat: position.coords.latitude,
            lng: position.coords.longitude
          });
          setLoading(false);
        },
        (error) => {
          console.error('Error getting location:', error);
          setError('Nem sikerült megszerezni a jelenlegi helyzetet');
          setLoading(false);

          setCurrentPosition({
            lat: 47.4979,
            lng: 19.0402
          });
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 60000
        }
      );
    } else {
      setError('A böngésző nem támogatja a geolokációt');
      setLoading(false);

      setCurrentPosition({
        lat: 47.4979,
        lng: 19.0402
      });
    }
  }, [vehiclePosition]);

  if (loading) {
    return (
      <div style={{ 
        height, 
        width, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        backgroundColor: '#f0f0f0',
        borderRadius: '8px'
      }}>
        Térkép betöltése...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        height, 
        width, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        backgroundColor: '#ffebee',
        color: '#c62828',
        borderRadius: '8px',
        padding: '16px',
        textAlign: 'center'
      }}>
        {error}
      </div>
    );
  }

  if (!currentPosition) {
    return null;
  }

  return (
    <div style={{ height, width, borderRadius: '8px', overflow: 'hidden' }}>
      <MapContainer
        key={mapKey}
        center={currentPosition}
        zoom={13}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={currentPosition}>
          <Popup>
            <div>
              <strong>{vehiclePosition ? 'Autó utolsó pozíciója' : 'Jelenlegi helyzet'}</strong><br />
              {vehiclePosition && vehiclePosition.timestamp && (
                <small>Időpont: {new Date(vehiclePosition.timestamp).toLocaleString('hu-HU')}</small>
              )}
            </div>
          </Popup>
        </Marker>
        <MapUpdater center={currentPosition} />
      </MapContainer>
    </div>
  );
};

export default LiveMap;
